// Collapsible mobile menu that shows the header

class CollapseMobileMenu {
    constructor() {
        this.mobileMenu = document.querySelector(".wp-block-navigation__responsive-container");
        this.toggleButton = document.querySelectorAll(".wp-block-navigation-submenu__toggle");
        this.closeSVG = document.querySelector('.wp-block-navigation__responsive-container-close > svg');
        this.hamburgerIcon = document.querySelector('.wp-block-navigation__responsive-container-open');
        this.hamburgerSVG = document.querySelector('.wp-block-navigation__responsive-container-open > svg');
        this.background = document.querySelector('.wp-site-blocks > div');
        this.events();
    }

    events() {
        this.toggleButton.forEach(item => {
            item.addEventListener('click', function() {
                item.parentElement.classList.toggle('show');
            });
        })

        if (this.hamburgerIcon) {
            this.hamburgerIcon.addEventListener('click', () => {
                if (this.hamburgerIcon.classList.contains('toggle')) {
                    this.hamburgerIcon.classList.remove('toggle');
                    this.closeSVG.replaceWith(this.hamburgerSVG);
                    this.mobileMenu.style.display = 'none';
                    this.background.classList.remove('darken');
                } else {
                    this.hamburgerIcon.classList.add('toggle');
                    this.hamburgerSVG.replaceWith(this.closeSVG);
                    this.mobileMenu.style.display = 'block';
                    this.background.classList.add('darken');
                }
            })
        }

        window.addEventListener('resize', () => {
            if (window.innerWidth > 600) {
                this.mobileMenu.classList.remove('is-menu-open');
                this.mobileMenu.classList.remove('has-modal-open');
                this.mobileMenu.style.display = 'block';
                if (this.background && this.background.classList.contains('darken')) {
                    this.background.classList.remove('darken');
                }
            } else if (window.innerWidth < 600) {
                this.mobileMenu.removeAttribute('style');
            }
        });


    };

    }

export default CollapseMobileMenu;